(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/models/result-month.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/models/result-month.js');

'use strict';

svs.numbergames.results.models.ResultMonth = svs.numbergames.core.NumbergamesModel.extend({
  defaults: {
    year: undefined,
    month: undefined,
    dates: {},
    productId: ''
  },
  url() {
    const {
      month,
      year,
      productId
    } = this.attributes;
    const datePickerMonth = month + 1;
    const productName = svs.numbergames.productMapping.getProductName(productId).toLowerCase();
    const productUrl = "/draw/1/results/datepicker?product=".concat(productName, "&year=").concat(year, "&month=").concat(datePickerMonth);
    const jokerUrl = "/draw/1/results/datepicker?product=joker&year=".concat(year, "&month=").concat(datePickerMonth);
    let url = svs.core.jupiter.url();
    if (svs.numbergames.productMapping.hasJoker(productId)) {
      url += "/multifetch?urls=".concat(encodeURIComponent(productUrl), "|").concat(encodeURIComponent(jokerUrl));
    } else {
      url += productUrl;
    }
    return url;
  },
  parse(attrs) {
    let datePicker;
    let addonDatePicker;
    if (attrs.datePicker) {
      ({
        datePicker,
        addonDatePicker
      } = attrs);
    } else if (attrs.responses) {
      [datePicker, addonDatePicker] = attrs.responses;
    } else {
      datePicker = attrs;
    }
    return {
      year: datePicker.year,
      month: datePicker.month - 1,
      dates: svs.numbergames.results.parsers.datePicker.parseDates(datePicker, addonDatePicker) || {},
      productId: svs.numbergames.productMapping.getProductId(datePicker.product)
    };
  },
  getAvailableDates() {
    const {
      year,
      month,
      dates
    } = this.attributes;
    const drawDates = [];

    for (const date in dates) {
      drawDates.push([year, month, Number(date)]);
    }
    return drawDates;
  },
  getLatestDraw() {
    const drawDates = Object.keys(this.get('dates')).sort((a, b) => a - b);
    return this.getDrawByDate(drawDates.pop());
  },
  getDrawByDate(dayOfMonth) {
    const dates = this.get('dates');
    return dates[dayOfMonth];
  }
});

 })(window);